// Рассылки всегда по киевскому времени, в какой бы стране ни был открыт экран: «в 10:00» значит
// 10:00 по Киеву, а не по часам компьютера.
//
// Расписание (schedule.js) считает дни и часы обычными датами браузера. Поэтому здесь два
// перехода: момент → «киевские часы» (дата, у которой часы и день те, что сейчас в Киеве) и
// обратно, перед отправкой на сервер.

// Старое имя зоны: «Europe/Kyiv» знают не все браузеры, «Europe/Kiev» — все.
export const KYIV_ZONE = 'Europe/Kiev';

const parts = new Intl.DateTimeFormat('en-US', {
  timeZone: KYIV_ZONE,
  hourCycle: 'h23',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
});

const fieldsOf = (date) => {
  const result = {};
  parts.formatToParts(date).forEach((part) => {
    result[part.type] = Number(part.value);
  });
  // Некоторые браузеры пишут полночь как 24.
  result.hour %= 24;
  return result;
};

// Момент (Date или ISO) → дата, у которой часы и день как сейчас в Киеве.
export const toKyivWall = (instant) => {
  const date = instant instanceof Date ? instant : new Date(instant);
  if (Number.isNaN(date.getTime())) return date;
  const f = fieldsOf(date);
  return new Date(f.year, f.month - 1, f.day, f.hour, f.minute, f.second, date.getMilliseconds());
};

// Сейчас по Киеву.
export const kyivNow = () => toKyivWall(new Date());

// На сколько миллисекунд Киев впереди UTC в этот момент (зимой 2 часа, летом 3).
const offsetAt = (ms) => {
  const f = fieldsOf(new Date(ms));
  const asUtc = Date.UTC(f.year, f.month - 1, f.day, f.hour, f.minute, f.second);
  return asUtc - Math.floor(ms / 1000) * 1000;
};

// «Киевские часы» → настоящий момент: что отправлять серверу.
export const fromKyivWall = (wall) => {
  const asUtc = Date.UTC(
    wall.getFullYear(),
    wall.getMonth(),
    wall.getDate(),
    wall.getHours(),
    wall.getMinutes(),
    wall.getSeconds(),
    wall.getMilliseconds()
  );
  // Второй шаг нужен у перевода часов: смещение берётся уже в найденный момент.
  const first = asUtc - offsetAt(asUtc);
  return new Date(asUtc - offsetAt(first));
};
